import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

type FooterProps = {
  ctaHeadingLevel?: 'h2' | 'p';
};

const Footer = ({ ctaHeadingLevel = 'p' }: FooterProps) => {
  const CtaHeading = ctaHeadingLevel;

  return (
    <>
      {/* CTA Section */}
      <section className="bg-[#f8f9fa] py-24 px-4 md:px-12">
        <div className="max-w-7xl mx-auto bg-[#113A28] rounded-[2rem] p-10 md:p-16 flex flex-col md:flex-row items-center justify-between gap-10">
          
          <CtaHeading className="text-3xl md:text-4xl font-bold text-white leading-tight">
            Build Up Your Skills Today <br /> And Get The Career You Want
          </CtaHeading>

          <Link to="/login/?mode=signup">
            <button className="bg-[#4CE470] text-[#113A28] px-8 py-3 rounded-lg font-bold text-sm hover:bg-[#3bc45d] transition-colors">
              JOIN NOW
            </button>
          </Link>

        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#F8F9FA] pt-20 pb-8 px-6 md:px-12 text-gray-800">
        <div className="max-w-7xl mx-auto">

          {/* Top Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16">

            {/* Brand */}
            <div>
              <Link to="/" className="inline-block mb-6">
                <img src="/Logo-footer.svg" alt="LearnWebAcademy Logo" width="234" height="45" />
              </Link>

              <p className="text-sm text-gray-500 max-w-sm leading-relaxed">
                Learn To Make Websites With Confidence. Education that moves with
                you — anytime, anywhere.
              </p>
            </div>

            {/* Platform Links */}
            <div>
              <p className="font-bold text-[#113A28] mb-4">Platform</p>

              <ul className="space-y-3 text-sm text-gray-500">
                <li>
                  <Link to="/" className="hover:text-[#4CE470]">Home</Link>
                </li>
                <li>
                  <Link to="/library/" className="hover:text-[#4CE470]">Library</Link>
                </li>
                <li>
                  <Link to="/terms/" className="hover:text-[#4CE470]">
                    Terms and conditions
                  </Link>
                </li>
                <li>
                  <Link to="/privacy/" className="hover:text-[#4CE470]">
                    Privacy policy
                  </Link>
                </li>
                      <li>
                  <Link to="/imprint/" className="hover:text-[#4CE470]">
                    Imprint
                  </Link>
                </li>
              </ul>
            </div>

            {/* Company */}
           <div className="space-y-2">
              <p className="font-bold text-[#113A28] mb-4">Company Details</p>

              <p className="text-sm text-gray-500">
                Company Name: OLBMI ltd.
              </p>

              <p className="text-sm text-gray-500">
                Company Address: 10 Mnasiadou, 2nd Floor, 1065 Nicosia
              </p>

              <p className="text-sm text-gray-500">
                Email: support@learnwebacademy.net
              </p>
            </div>
          </div>

          {/* Support Section */}
          <div className="border-t border-gray-200 pt-12 pb-6">

            <span className="inline-block mb-6 text-xs font-semibold tracking-wider text-gray-500 border border-gray-300 rounded-full px-4 py-1.5">
              Get In Touch With Us Today
            </span>

            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">

              <p className="text-5xl md:text-8xl font-black text-[#113A28] tracking-tighter">
                NEED SUPPORT
              </p>

              <a
                href="https://learnwebcare.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#2A2A2A] p-4 md:p-6 rounded-full text-white hover:bg-[#4CE470] hover:text-[#113A28] transition-colors"
                aria-label="Open support website"
              >
                <ArrowRight size={40} />
              </a>

            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-gray-200 pt-6 mt-6 text-xs text-gray-400 flex flex-col md:flex-row justify-between">

            <p>Copyright © 2026 LearnWebAcademy. All Rights Reserved.</p>

            <div className="flex gap-4 mt-4 md:mt-0">
              <Link to="/privacy/" className="hover:text-gray-600">
                Privacy Policy
              </Link>

              <Link to="/terms/" className="hover:text-gray-600">
                Terms & Conditions
              </Link>
            </div>

          </div>

        </div>
      </footer>
    </>
  );
};

export default Footer;
